<template>
    <div class="preview">
        <template v-if="itemObj.url">
            <div class="preview_con" :class="{'preview_con_ver ': itemObj.vertically == 4}">
                <video :src="itemObj.url" autoplay="autoplay" loop="loop"  class="video" ></video>
            </div>
        </template>
        <div class="process" v-else>
            <p>{{itemObj.process}}%</p>
            <el-progress :percentage="itemObj.process" :show-text="false" style="width: 70%"></el-progress>
        </div>
        <el-button @click="reloadFile" class="reloadFile">
            <i class="iconfont">&#xe60f;</i>
            <span style="margin-left: 6px">重新上传</span>
        </el-button>
        <img src="@/assets/image/douyin_header.png" class="douyin_header"/>
        <ul class="preview_nav">
            <li>
                <img :src="avatar_url" alt=""/>
            </li>
            <li>
                <span class="iconfont">&#xe60e;</span>
            </li>
            <li>
                <span class="iconfont">&#xe606;</span>
            </li>
             <li>
                <img src="@/assets/image/douyin1.png" alt=""/>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        itemObj: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            avatar_url: localStorage.getItem('avatar_url') || ''
        }
    },
    // components: {
    //     'audio-element': AudioElement
    // },
    methods: {
        reloadFile() {
            this.$emit('reloadFile')
        }
    }
}
</script>
<style lang="less" scoped>
    .preview {
        background: url('~@/assets/image/douyin_preview.png') no-repeat;
        width: 280px;
        height: 605px;
        background-size: 280px 605px;
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        .preview_con {
            width: 270px;
            height: 491px;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 16px;
            border-top-left-radius: 25px;
            border-top-right-radius: 25px;
            overflow: hidden;
            background-color: #1c1c1c;
            .video {
                width: 100%;
                object-fit: contain;
            }
        }
        .preview_nav {
            width: 60px;
            position: absolute;
            top: 50%;
            right: 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            li {
                width: 34px;
                height: 34px;
                display: flex;
                justify-content: flex-end;
                &:not(:last-child) {
                    margin-bottom: 22px;
                }
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 100%;
                }
                span {
                    font-size: 28px;
                    color: #fff;
                }
            }
        }
        .process {
            border-radius: 16px 16px 0 0;
            width: 100%;
            height: calc(100% - 110px);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            top: 18px;
            background-color: rgba(0, 0, 0, 0.3);
        }
    }
    .douyin_header {
        width: 150px;
        height: 30px;
        position: absolute;
        top: 7px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 99;
    }
    .reloadFile {
        position: absolute;
        bottom: -60px;
        left: 50%;
        transform: translateX(-50%);
    }
</style>